// extracted by mini-css-extract-plugin
module.exports = {"hover":"CardHover_hover__z0V7o","left":"CardHover_left__2kHu_"};